module.exports = __webpack_public_path__ + "img/Bootsgruppe.8a9a7079.svg";